import React, { FC } from "react";
import { Box, Link } from "@chakra-ui/react";
import { graphql, useStaticQuery } from "gatsby";

type PromoBannerProps = {
  loggedIn: boolean;
  isUnlicensedUser: boolean;
};

const PromoBanner: FC<PromoBannerProps> = ({ loggedIn, isUnlicensedUser }) => {
  const data = useStaticQuery(graphql`
    query PromoBannerQuery {
      wpPage(slug: { eq: "single-product-page" }) {
        promoBanner {
          bannerLicensed {
            linkToLicensed
            bannerBackgroundLicensed {
              sourceUrl
            }
            bannerImageLicensed {
              sourceUrl
            }
          }
          bannerUnlicensed {
            linkTo
            bannerBackgroundUnlicensed {
              sourceUrl
            }
            bannerImage {
              sourceUrl
            }
          }
        }
      }
    }
  `);

  const promoBanner = data?.wpPage?.promoBanner;

  const bannerImage =
    loggedIn && !isUnlicensedUser
      ? promoBanner?.bannerLicensed?.bannerImageLicensed?.sourceUrl
      : promoBanner?.bannerUnlicensed?.bannerImage?.sourceUrl;

  const bannerLink =
    loggedIn && !isUnlicensedUser
      ? promoBanner?.bannerLicensed?.linkToLicensed
      : promoBanner?.bannerUnlicensed?.linkTo;

  const bannerBackground =
    loggedIn && !isUnlicensedUser
      ? promoBanner?.bannerLicensed?.bannerBackgroundLicensed?.sourceUrl
      : promoBanner?.bannerUnlicensed?.bannerBackgroundUnlicensed?.sourceUrl;

  return (
    <Link href={bannerLink}>
      <Box
        pt="20px"
        bg="#fff"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          height: "142px",
          width: "100%",
          overflow: "hidden",
          zIndex: 10,
        }}
      >
        {/* Dynamic background image */}
        <Box
          backgroundImage={`url(${bannerBackground})`}
          bgSize="cover"
          bgPosition="center"
          height="170px"
          width="100%"
          zIndex={1}
        ></Box>
        <img
          src={bannerImage}
          alt="Promo Banner Content"
          style={{
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
            objectFit: "contain",
            backgroundColor: "transparent !important",
            zIndex: 2,
          }}
        />
      </Box>
    </Link>
  );
};

export default PromoBanner;
